// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2VpAD","infoBtn":"quickbooks_infoBtn__ED2Q_","formBox":"quickbooks_formBox__x4Qgj","formFooter":"quickbooks_formFooter__1CQsm"};